"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkSignalLevelLostConnectionText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const room_session_1 = require("../../../../context/room_session");
const rxjs_1 = require("../../../../hooks/rxjs");
const NetworkSignalLevelLostConnectionText = ({ showNetworkQuality, }) => {
    const roomSession = (0, room_session_1.useRoomSession)();
    const [remoteNetworkQuality] = (0, rxjs_1.useObservable)(roomSession.media.remoteNetworkQuality);
    const [showErrorMessage, setShowErrorMessage] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!showNetworkQuality || remoteNetworkQuality !== 0) {
            setShowErrorMessage(false);
        }
        else {
            setShowErrorMessage(true);
        }
    }, [remoteNetworkQuality, showNetworkQuality]);
    return ((0, jsx_runtime_1.jsx)(NetworkSignalLevelLostConnectionTextContainer, { children: showErrorMessage && ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ "data-testid": "lost-connection-error", as: "p", color: "red50", size: "small", style: { marginLeft: '40px', lineHeight: '18px' } }, { children: "Lost Connection or Switching Networks" }))) }));
};
exports.NetworkSignalLevelLostConnectionText = NetworkSignalLevelLostConnectionText;
const NetworkSignalLevelLostConnectionTextContainer = (0, ui_react_1.styled)(ui_react_1.Flex)(() => ({
    height: '18px',
    marginBottom: '20px',
}));
//# sourceMappingURL=network_quality_lost_connection_text.js.map